// Footer.jsx
import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Popover, Text, Button, Group, Stack } from "@mantine/core";
import { IconQuestionMark, IconCopyright } from "@tabler/icons-react";
import Messages from "../StreamChat/Messages";
import styles from "./Footer.module.scss";

const HelpPopoverContent = ({ hidePopover }) => (
  <div className={styles.popoverContent}>
    <Stack spacing="xs">
      <Text size="lg" fw={700} align="center" className={styles.heading}>
        Help & Resources
      </Text>
      <Group position="apart" spacing="xl">
        <ul className={styles.linkList}>
          <li>
            <Link onClick={() => hidePopover()} href="/">
              Home
            </Link>
          </li>
          <li>
            <Link onClick={() => hidePopover()} href="/courses">
              Courses
            </Link>
          </li>
          <li>
            <Link onClick={() => hidePopover()} href="/about">
              About
            </Link>
          </li>
          <li>
            <Link onClick={() => hidePopover()} href="/contact">
              Contact
            </Link>
          </li>
        </ul>
        <ul className={styles.linkList}>
          <li>
            <Link onClick={() => hidePopover()} href="/faq">
              FAQs
            </Link>
          </li>
          <li>
            <Link onClick={() => hidePopover()} href="/cookie-policy">
              Cookie Policy
            </Link>
          </li>
          <li>
            <Link onClick={() => hidePopover()} href="/privacy-policy">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link onClick={() => hidePopover()} href="/terms-of-service">
              Terms & Conditions
            </Link>
          </li>
        </ul>
      </Group>
      <Group position="center">
        <Text size="xs" fz="xs" align="center">
          <IconCopyright size={16} /> {new Date().getFullYear()} Coursepage LLC
        </Text>
      </Group>

      <Group gap="sm" position="center" spacing="xs" mt="xs">
        <a href="https://www.facebook.com/people/Coursepage/61560865569177/" target="_blank" rel="noopener noreferrer">
          <Image src="/icons/facebook-48.png" alt="Facebook" width={24} height={24} />
        </a>

        <a href="https://x.com/coursepage12" target="_blank" rel="noopener noreferrer">
          <Image src="/icons/twitter-48.png" alt="Twitter" width={24} height={24} />
        </a>

        <a href="https://www.linkedin.com/company/coursepage" target="_blank" rel="noopener noreferrer">
          <Image src="/icons/linkedin-48.png" alt="LinkedIn" width={24} height={24} />
        </a>

        <a href="https://www.youtube.com/@coursepage" target="_blank" rel="noopener noreferrer">
          <Image src="/icons/youtube-48.png" alt="YouTube" width={24} height={24} />
        </a>

        <a href="https://discord.gg/YQfkzxNe9x" target="_blank" rel="noopener noreferrer">
          <Image src="/icons/discord.png" alt="Discord" width={24} height={24} />
        </a>
      </Group>
    </Stack>
  </div>
);

const Help = () => {
  const [opened, setOpened] = useState(false);

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      width={240}
      position="bottom"
      withArrow
      shadow="md"
      closeOnClickOutside
      withinPortal={false}
      transition="pop"
      styles={{ dropdown: { borderRadius: "10px" } }}
    >
      <Popover.Target>
        <Button onClick={() => setOpened((o) => !o)} className={styles.helpButton}>
          <IconQuestionMark size={16} />
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <HelpPopoverContent hidePopover={() => setOpened(false)} />
      </Popover.Dropdown>
    </Popover>
  );
};

const Footer = ({ user }) => {
  return (
    <div id="footer" className={styles.footerContainer}>
      <div className={styles.helpIconContainer}>
        <Help />
      </div>
      <div className={styles.footerArea}>
        <Messages user={user} />
      </div>
    </div>
  );
};

export default Footer;
